import { JOURNEY_ROUTES } from '../../../core/constants/journey-routes';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { menu } from './menu-items';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, SidebarModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  readonly journeyRoutes = JOURNEY_ROUTES;
  items_sidebar: Array<any> = menu;
  visible!: boolean;
  @Input() toogle!: boolean;
  @Output() changeToogle = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}

  handleChangeToogle(event: any) {
    this.toogle = event;
    this.changeToogle.emit(event);
  }

  handleCloseToogle() {
    this.changeToogle.emit(false);
  }
}
